import { useContext, useState, useMemo, useEffect} from "react";

import "./RevisioniResults.scss";

import { AppContext } from "../../../../../../core/contexts/AppContext";

import RevisioniReactTable from "../RevisioniReactTable/RevisioniReactTable";
import ButtonWithIcon from "../../../../../../shared/components/buttons/ButtonWithIconAlt/ButtonWithIconAlt";
import ModalPortal from "../../../../../../core/portals/ModalPortal/ModalPortal";
import ModalMessage from "../ModalMessage/ModalMessage";

type VehicleDataResults = {
    vehicleData?: any,
    plate: string,
    vehicleType: string
}

const RevisioniResults = ({vehicleData, plate, vehicleType} : VehicleDataResults) => {
    //Stato usato per gestire l'apertura/chiusura della modale
    const [showModal, setShowModal] = useState(false);
    const { appText } = useContext(AppContext);
    const { REVISIONI_TEXT } = appText;

    /* Side effect che blocca lo scroll della pagina all'apertura della modale */ 
    useEffect(() => {
        if(showModal){
            document.body.classList.add("remove-scroll");
        }else{
            document.body.classList.remove("remove-scroll");
        }
    }, [showModal]);

    //Funzione usata per la chiusura della modale
    const closeModal = () => setShowModal(false);
    //Funzione usata per l'apertura della modale
    const openModal = () => setShowModal(true);
    
    // memo per la creazione della tabella
    const columns = useMemo(
        () => [
          {
            Header: REVISIONI_TEXT.TABLE_HEADING_FIRST_FIELD,
            accessor: "date",
          },
          {
            Header: REVISIONI_TEXT.TABLE_HEADING_SECOND_FIELD,
            accessor: "result",
          },
          {
            Header: REVISIONI_TEXT.TABLE_HEADING_THIRD_FIELD,
            accessor: "km",
          },
          {
            Header: REVISIONI_TEXT.TABLE_HEADING_TARGA,
            accessor: "plate",
          },
          {
            Header: "",
            accessor: "empty",
          },
        ],
        [
            REVISIONI_TEXT.TABLE_HEADING_FIRST_FIELD,
            REVISIONI_TEXT.TABLE_HEADING_SECOND_FIELD,
            REVISIONI_TEXT.TABLE_HEADING_THIRD_FIELD,
            REVISIONI_TEXT.TABLE_HEADING_TARGA,
        ]
    );

    return (
        <>
            <div className="RevisioniResults">
                <div className="container">
                    <div className="RevisioniResults__top row">
                        <h4 className="RevisioniResults__title">
                            {REVISIONI_TEXT.RESULTS_HEADING}
                        </h4>
                        {/* Bottone per apertura modale */}
                        <ButtonWithIcon
                            type={"warning"}
                            size={"medium"}
                            icon={"bi bi-exclamation-circle"}
                            cbClick={openModal}
                            title={REVISIONI_TEXT.RESULTS_MODAL_BTN_TITLE}    
                        />
                    </div>
                    {/* Informazioni del veicolo */}
                    <p className="RevisioniResults__info">
                        <span className="RevisioniResults__voice">
                            {REVISIONI_TEXT.RESULTS_INFO_TITLE_FIRST} : 
                            <span className="RevisioniResults__data">{vehicleType}</span>
                        </span>
                        <span className="RevisioniResults__voice">
                            {REVISIONI_TEXT.RESULTS_INFO_TITLE_SECOND} : 
                            <span className="RevisioniResults__data">{plate}</span>
                        </span>
                    </p>
                    {/* Tabella delle revisioni */}
                    {typeof vehicleData !== "undefined" &&
                        <RevisioniReactTable
                            columns={columns}
                            data={vehicleData["inspections"]}
                            displaysMissingDataError={false}
                            initialState={{ pageIndex: 0 }}
                            //tableHooks={[useFooPlugin]}
                        />
                    }
                </div>
            </div>
            {/* Componente della modale con il suo contenuto */}
            {showModal &&
                <ModalPortal 
                    display={showModal} 
                    onClose={closeModal}
                    element={ 
                        <ModalMessage 
                            title={REVISIONI_TEXT.MODAL_TEXT_TITLE} 
                            message={REVISIONI_TEXT.MODAL_TEXT_MESSAGE}
                            icon={"bi bi-exclamation-circle"}
                            onClose={closeModal}
                        />
                    }
                />
            }
        </>
    );
};

export default RevisioniResults;
